var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import { defaultProps } from './defaults';
import { NewPagination, } from '@feb-team/data-logic';
import { ArrowRightOutlined, ArrowLeftOutlined } from '@feb-team/legao-icons-react';
import { ButtonTag, DivTag } from '../../Utils/AtomicTag';
var Pagination = /** @class */ (function (_super) {
    __extends(Pagination, _super);
    function Pagination(props) {
        var _this = _super.call(this, props) || this;
        _this.renderPartial = function (item) {
            switch (item.type) {
                case 'ellipsis':
                    return _this.renderEllipsis(item);
                case 'item':
                    return _this.renderPage(item);
                case 'prev':
                    return _this.renderPrev(item);
                case 'next':
                    return _this.renderNext(item);
                default:
                    console.error("not supported type " + item);
            }
        };
        try {
            if (!props.current) {
                props.current = props.defaultCurrent;
            }
            // 调用 data-logic 包中的专用工厂方法进行实例化
            // 自动将组件 props 转换成实体类构造方法的入参
            _this.entity = NewPagination(props);
        }
        catch (e) {
            console.error('入参出错：', e.message);
            console.log(props);
        }
        // 状态初始化
        _this.state = {
            items: _this.items,
        };
        return _this;
    }
    Pagination.prototype.componentWillReceiveProps = function (nextProps, nextContext) {
        if (nextProps.current != this.props.current) {
            this.goTo(nextProps.current);
        }
    };
    Object.defineProperty(Pagination.prototype, "items", {
        get: function () {
            // 调用实体类中的方法，生产数据
            return this.entity ? this.entity.build() : [];
        },
        enumerable: false,
        configurable: true
    });
    Pagination.prototype.handleChange = function (page, fn) {
        if (this.props.onBeforeChange(page)) {
            fn();
            this.props.onChange(page);
        }
    };
    Pagination.prototype.renderPage = function (item) {
        var _this = this;
        var atomics = [
            'px-2',
            'py-px-2',
            'mr-px-4',
            'border-solid',
            'border',
            'hover:border-brand-600',
            'rounded-sm',
            'text-center',
            'cursor-pointer',
        ];
        if (item.active) {
            atomics.push('border-brand-600', 'text-brand-600', 'font-bold');
        }
        else {
            atomics.push('border-gray-300');
        }
        return (React.createElement(ButtonTag, { atomics: atomics, key: item.page, autoPrefixedClassName: item.active ? 'pagination-item pagination-item-active' : 'pagination-item', onClick: function () {
                _this.handleChange(item.page, function () { return _this.goTo(item.page); });
            } }, item.page));
    };
    Pagination.prototype.renderPrev = function (item) {
        var _this = this;
        var prevText = this.props.prevText;
        var atomics = [
            'px-2',
            'py-px-2',
            'mr-px-4',
            'border-solid',
            'border',
            'border-gray-300',
            'text-center',
            'rounded-sm',
            'cursor-pointer',
        ];
        if (item.disabled) {
            atomics.push('cursor-not-allowed', 'text-gray-500', 'bg-gray-100');
        }
        else {
            atomics.push('hover:border-brand-600');
        }
        return (React.createElement(ButtonTag, { key: item.type, atomics: atomics, disabled: item.disabled, autoPrefixedClassName: "pagination-prev", onClick: function () {
                _this.handleChange(_this.entity.prev, function () { return _this.goPrev(); });
            } }, prevText ? prevText : React.createElement(ArrowLeftOutlined, null)));
    };
    Pagination.prototype.renderNext = function (item) {
        var _this = this;
        var nextText = this.props.nextText;
        var atomics = [
            'px-2',
            'py-px-2',
            'mr-px-4',
            'border-solid',
            'border',
            'border-gray-300',
            'rounded-sm',
            'text-center',
            'cursor-pointer',
        ];
        if (item.disabled) {
            atomics.push('cursor-not-allowed', 'text-gray-500', 'bg-gray-100');
        }
        else {
            atomics.push('hover:border-brand-600');
        }
        return (React.createElement(ButtonTag, { atomics: atomics, key: item.type, disabled: item.disabled, onClick: function () {
                _this.handleChange(_this.entity.next, function () { return _this.goNext(); });
            }, autoPrefixedClassName: "pagination-next" }, nextText ? nextText : React.createElement(ArrowRightOutlined, null)));
    };
    Pagination.prototype.renderEllipsis = function (item) {
        var atomics = [
            'h-px-24',
            'min-w-px-24',
            'mr-px-4',
            'border-0',
            'text-center',
        ];
        return (React.createElement(ButtonTag, { key: item.type + item.dir, atomics: atomics, autoPrefixedClassName: "pagination-ellipsis" }, this.props.ellipsisText));
    };
    Pagination.prototype.render = function () {
        return (React.createElement(DivTag, { name: Pagination.NAME, className: this.props.className, style: this.props.style }, this.entity && this.state.items.map(this.renderPartial)));
    };
    Pagination.prototype.goTo = function (page) {
        if (!this.entity)
            return;
        // 调用实体类中的 action 方法
        this.entity.goTo(page);
        this.setState({ items: this.items });
    };
    Pagination.prototype.goPrev = function () {
        this.entity.goPrev();
        this.setState({ items: this.items });
    };
    Pagination.prototype.goNext = function () {
        this.entity.goNext();
        this.setState({ items: this.items });
    };
    // 默认参数，单独从外部文件引入
    Pagination.defaultProps = defaultProps;
    Pagination.NAME = 'pagination';
    Pagination.displayName = 'Pagination';
    return Pagination;
}(Component));
export { Pagination };
